var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.465 6.954C21.863 6.954 23 8.16 23 9.642v9.414C23 20.679 21.754 22 20.222 22H3.777C2.246 22 1 20.68 1 19.056V9.642C1 8.16 2.137 6.954 3.535 6.954h2.952C6.58 5.308 7.873 4 9.448 4h5.104c1.575 0 2.868 1.308 2.96 2.954h2.953zM7.5 13.693c0 2.502 2.02 4.538 4.5 4.538 2.481 0 4.5-2.036 4.5-4.538 0-2.503-2.019-4.54-4.5-4.54-2.48 0-4.5 2.037-4.5 4.54zm10.688-4.155a.69.69 0 00-.688.693.69.69 0 00.688.692h1.375a.69.69 0 00.687-.692.69.69 0 00-.688-.693h-1.375z",
    fill: "#0C1014",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.53fbdef5b8076265a6b0d8d8d923a6fc.svg";
export { ForwardRef as ReactComponent };